import React, { useState, useEffect } from "react";
import Hoc from "../../components/HOC";
import CustomDataTable from "../../components/CustomDataTable";
import { FaCog, FaPlus } from "react-icons/fa";
import { MdVisibility, MdEdit } from "react-icons/md";
import ModalComponent from "../../components/Modal";
import { Formik } from "formik";
import TextInput from "../../components/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { requestAdminPreference, requestAdminPreferenceList, requestAdminPreferenceById, requestAdminPreferenceEdit, setResetAdminPreferenceState, setResetAdminPreferenceEdit, setResetAdminPreferenceById, setResetAdminPreferenceListState } from "../../Redux/AdminPreferencesState/AdminPrefrenceActionCreator";
import { toast } from "react-toastify";
import AdminPreferenceService from "../../Services/RestApiManager/AdminPrefrencesManager/AdminPrefrencesService";
import { AdminPreferenceSchema } from "../../components/Helpers";

const Adminprefrences = () => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // 'add', 'view', or 'edit'
  const [viewData, setViewData] = useState(null);
  const dispatch = useDispatch();
  const adminPreferencesState = useSelector(
    (state) => state.AdminprefrencesReducer
  );
  const getAdminprefrenceState = useSelector(
    (state) => state.AdminPrefrenceListReducer
  );
  const adminPreferenceByIdState = useSelector(
    (state) => state.AdminPrefrenceByIdReducer
  );
  const adminPreferenceEditState = useSelector(
    (state) => state.AdminPrefrenceEditReducer
  );

  const filteredData = data.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(search.toLowerCase())
    )
  );

  const handleView = (row) => {
    setViewData(row);
    setModalMode("view");
    setShowModal(true);
  };

  const handleEdit = (row) => {
    dispatch(setResetAdminPreferenceState());
    dispatch(setResetAdminPreferenceEdit());
    dispatch(setResetAdminPreferenceListState());
    dispatch(requestAdminPreferenceById(row.companyName));
    setModalMode("edit");
    setShowModal(true);
  }; 

  const columns = [
    {
      name: "Company Name",
      selector: (row) => row.companyName,
      sortable: true,
    },
    {
      name: "Timesheet Emails",
      selector: (row) => row.timesheetEmails,
      sortable: true,
    },
    { name: "HR Emails", selector: (row) => row.hrEmails, sortable: true },
    {
      name: "Accounts Emails",
      selector: (row) => row.accountsEmails,
      sortable: true,
    },
    { name: "Site Link", selector: (row) => row.siteLink, sortable: true },
    { name: "Phone", selector: (row) => row.phone, sortable: true },
    {
      name: "Action",
      cell: (row, idx) => (
        <div className="flex gap-2">
          <button
            className="text-cyan-800 hover:text-cyan-600 p-2 rounded-full"
            title="View"
            onClick={() => handleView(row)}
          >
            <MdVisibility size={22} />
          </button>
          <button
            className="text-cyan-800 hover:text-cyan-600 p-2 rounded-full"
            title="Edit"
            onClick={() => handleEdit(row)}
          >
            <MdEdit size={22} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const initialFormState = {
    companyName: "",
    timesheetEmails: "",
    hrEmails: "",
    accountsEmails: "",
    siteLink: "",
    phone: "",
  };

  const [editInitialValues, setEditInitialValues] = useState(initialFormState);

  const handleSubmit = (values) => {
    dispatch(requestAdminPreference(values));
    dispatch(setResetAdminPreferenceListState());
  };

  useEffect(() => {
    dispatch(setResetAdminPreferenceState());
    dispatch(setResetAdminPreferenceEdit());
    dispatch(setResetAdminPreferenceById());
    dispatch(setResetAdminPreferenceListState());
    dispatch(requestAdminPreferenceList());
  }, []);

  useEffect(() => {
    if (getAdminprefrenceState && getAdminprefrenceState.isResponse) {
      setData(getAdminprefrenceState.isResponse);
    }
  }, [getAdminprefrenceState.isResponse]);

  useEffect(() => {
    if (!adminPreferencesState?.isLoading && adminPreferencesState?.isResponse) {
      toast.success("Admin preference added successfully!");
      setShowModal(false);
      dispatch(requestAdminPreferenceList());
      dispatch(setResetAdminPreferenceState());
    } else if (!adminPreferencesState?.isLoading && adminPreferencesState?.isError) {
      toast.error("Failed to add admin preference.");
      dispatch(setResetAdminPreferenceState());
    }
  }, [adminPreferencesState]);

  useEffect(() => {
    if (modalMode === "edit" && adminPreferenceByIdState?.isResponse) {
      setEditInitialValues(adminPreferenceByIdState.isResponse);
    }
  }, [adminPreferenceByIdState.isResponse, modalMode]);

  useEffect(() => {
    if (!adminPreferenceEditState?.isLoading && adminPreferenceEditState?.isResponse) {
      toast.success("Admin preference updated successfully!");
      setShowModal(false);
      dispatch(requestAdminPreferenceList());
      dispatch(setResetAdminPreferenceEdit());
    } else if (!adminPreferenceEditState?.isLoading && adminPreferenceEditState?.isError) {
      toast.error("Failed to update admin preference.");
      dispatch(setResetAdminPreferenceEdit());
    }
  }, [adminPreferenceEditState]);

  useEffect(() => {
    return () => {
      dispatch(setResetAdminPreferenceState());
      dispatch(setResetAdminPreferenceEdit());
      dispatch(setResetAdminPreferenceById());
      dispatch(setResetAdminPreferenceListState());
    };
  }, []);

  return (
    <div className="p-6 w-full h-[90vh]">
      <div className="flex items-center justify-between mb-4">
        <div />
        <button
          className="flex items-center gap-2 bg-cyan-800 text-white px-4 py-2 rounded hover:bg-cyan-900 transition"
          onClick={() => {
            setModalMode("add");
            setViewData(null);
            setShowModal(true);
          }}
        >
          <FaPlus />
        </button>
      </div>
      <CustomDataTable
        columns={columns}
        data={filteredData}
        pagination={false}
      />
      <ModalComponent
        show={showModal}
        onClose={() => setShowModal(false)}
        title={
          modalMode === "add"
            ? "Add Admin Preference"
            : modalMode === "edit"
            ? "Edit Admin Preference"
            : "View Admin Preference"
        }
      >
        <Formik
          initialValues={
            modalMode === "add"
              ? initialFormState
              : modalMode === "edit"
              ? editInitialValues
              : viewData || initialFormState
          }
          validationSchema={AdminPreferenceSchema}
          enableReinitialize
          onSubmit={async (values, { resetForm }) => {
            if (modalMode === "add") {
              if (adminPreferencesState.isLoading) return;
              await handleSubmit(values);
              resetForm();
            } else if (modalMode === "edit") {
              if (adminPreferenceEditState.isLoading) return;
              
              // Send the correct data structure expected by the backend
              const editPayload = {
                companyName: values.companyName,
                data: {
                  companyName: values.companyName,
                  timesheetEmails: values.timesheetEmails,
                  hrEmails: values.hrEmails,
                  accountsEmails: values.accountsEmails,
                  siteLink: values.siteLink,
                  phone: Number(values.phone)
                }
              };
              dispatch(requestAdminPreferenceEdit(editPayload));
            }
          }} 
        >
          {({ values, handleChange, handleSubmit ,errors, touched}) => (
            <form
              onSubmit={handleSubmit}
              className="bg-slate-50 rounded-xl shadow-inner p-6"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mb-8">
                <div className="flex flex-col gap-2">
                  <TextInput
                    name="companyName"
                    value={values.companyName}
                    handleChange={handleChange}
                    placeholder="Company Name"
                    legend
                    isDisabled={modalMode === "view" || modalMode === "edit"}

                  />
                   {errors.companyName && touched.companyName && (
                    <div className="text-red-500 text-sm text-left">
                      {errors.companyName}
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <TextInput
                    name="timesheetEmails"
                    value={values.timesheetEmails}
                    handleChange={handleChange}
                    placeholder="Timesheet Emails"
                    legend
                    isDisabled={modalMode === "view"}
                    type="email"
                  />
                   {errors.timesheetEmails && touched.timesheetEmails && (
                    <div className="text-red-500 text-sm text-left">
                      {errors.timesheetEmails}
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <TextInput
                    name="hrEmails"
                    value={values.hrEmails}
                    handleChange={handleChange}
                    placeholder="HR Emails"
                    legend
                    isDisabled={modalMode === "view"}
                    type="email"
                  />
                  {errors.hrEmails && touched.hrEmails && (
                    <div className="text-red-500 text-sm text-left">
                      {errors.hrEmails}
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <TextInput
                    name="accountsEmails"
                    value={values.accountsEmails}
                    handleChange={handleChange}
                    placeholder="Accounts Emails"
                    legend
                    isDisabled={modalMode === "view"}
                    type="email"
                  />
                  {errors.accountsEmails && touched.accountsEmails && (
                    <div className="text-red-500 text-sm text-left">
                      {errors.accountsEmails}
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <TextInput
                    name="siteLink"
                    value={values.siteLink}
                    handleChange={handleChange}
                    placeholder="Site Link"
                    legend
                    isDisabled={modalMode === "view"}
                  />
                   {errors.siteLink && touched.siteLink && (
                    <div className="text-red-500 text-sm text-left">
                      {errors.siteLink}
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <TextInput
                    name="phone"
                    value={values.phone}
                    handleChange={handleChange}
                    placeholder="Phone"
                    legend
                    isDisabled={modalMode === "view"}   
                  />
                   {errors.phone && touched.phone && (
                    <div className="text-red-500 text-sm text-left">
                      {errors.phone}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 order-2"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                {/* Submit button (only in add/edit mode) */}
                {(modalMode === "add" || modalMode === "edit") && (
                  <button
                    type="submit"
                    className="px-4 py-2 rounded bg-cyan-800 text-white hover:bg-cyan-900 shadow-md order-3"
                    disabled={adminPreferencesState.isLoading || adminPreferenceEditState.isLoading}
                  >
                    {adminPreferencesState.isLoading || adminPreferenceEditState.isLoading ? "Submitting..." : "Submit"}
                  </button>
                )}
              </div>
            </form>
          )}
        </Formik>
      </ModalComponent>
    </div>
  );
};

export default Hoc(Adminprefrences);
